import React from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import classNames from "classnames";

export const getTooltipTitleForChip = (elements: string[]) => (
    <div className="flex flex-col">
        {elements.map((e, i) => (
            <span key={`tooltip-chip-${i}`}>{e}</span>
        ))}
    </div>
);

export type DSTooltipProps = TooltipProps & {
    baseClassName?: string;
    disabled?: boolean;
};

const DSTooltip = ({
    children,
    baseClassName = "ds-tooltip__tooltip",
    className = "",
    disabled = false,
    ...props
}: DSTooltipProps) => {
    if (disabled) {
        // skip tooltip when disabled, just to avoid MUI errors.
        // Sometimes it's a little complicated to add a <span> tag or similar for css reasons
        return children;
    }
    return (
        <Tooltip classes={{ tooltip: classNames(baseClassName, className) }} {...props}>
            {children}
        </Tooltip>
    );
};

export const HTMLTooltip = (props: DSTooltipProps) => (
    <DSTooltip baseClassName="ds-html-tooltip__tooltip" {...props} />
);

export const RightTooltip = (props: DSTooltipProps) => <DSTooltip placement="right" {...props} />;

export default DSTooltip;
